// @flow

export default function isAndroid() {
   return !!navigator.userAgent.match(/Android/i);
}
